export interface I_Response {
    success: boolean,
    code: number,
    message: string,
    data: any
}

export interface I_FormOption {
    label: string,
    statId: string,
    state: boolean,
    Gps: [number, number]
}
export interface Lists_Type {
    /** 数据时间 */
    dateTime: string,
    /** 高度 */
    heighAlti: number,
    lon: number,
    lat: number,
    staId: string,
    vertDaRel: number,
    /** 风向 */
    winD: number,
    /** 风速 */
    winS: number,
    winVS: number | null,
    img: string,
    staName: string
};

export interface I_UparWprByLatLonRange {
    /** 数据类型 */
    dataType?: Enum_UparWprByLatLonRangeDataType,
    /** 范围类型 */
    rectType?: Enum_UparWprByLatLonRangerectType,
    /** 截止时间 */
    datetime?: string,
    minLat?: number,
    maxLat?: number,
    minLng?: number,
    maxLng?: number,
    /** 测样高度 */
    height?: number,
    /** 测样高度浮动范围 */
    fluctuate?: number
};

export enum Enum_UparWprByLatLonRangeDataType {
    实时数据 = "1",
    半小时平均数据 = "2",
    小时平均 = "3"
};

export enum Enum_UparWprByLatLonRangerectType {
    /** 海南（lat:1.3~20.1 log:106.1~120.35） */
    海南 = "1",
    /** 网格（lat:1.3~27 log:106.1~120.35） */
    网格 = "2",
    /** 自定义 */
    自定义 = "9"
}
